export type SystemStep = {
  step: string
  title: string
  body: string
}

/* 2026-09-08 (compliance, Kevin): Yelp flagged Viridia for review
   solicitation. Step 04 previously read "Follow-ups, reminders, and review
   requests run on their own", and packageIncludes carried "Reputation &
   review management". Both are removed. Do not reinstate any claim to
   request, generate, solicit, automate or manage reviews. */

export const systemSteps: SystemStep[] = [
  {
    step: '01',
    title: 'The lead comes in',
    body: 'Yelp, Google, your website, a referral texting the number off your truck. Every one of them lands in the same place instead of three apps you check at night.',
  },
  {
    step: '02',
    title: 'Something answers, every time',
    body: 'You are on a roof or under a sink. The AI receptionist picks up, and a missed call gets a text back in seconds, while they are still holding the phone.',
  },
  {
    step: '03',
    title: 'The ads keep the top full',
    body: 'Yelp and Google spend gets managed against booked jobs, not clicks. Your Google Business Profile is set up so the people already searching for you actually find you.',
  },
  {
    step: '04',
    title: 'The CRM keeps chasing',
    body: 'Nobody goes cold because you got busy. Follow-ups and reminders run on their own until the job is booked or they say no.',
  },
]

export const packageIncludes: string[] = [
  'Viridia CRM + Mobile app',
  'AI receptionist, built and tuned with you',
  'Missed-call text-back',
  'Business phone number + A2P registration',
  'Pipelines, workflows & automations built with you',
  'Social media + email marketing',
  'Invoicing with QuickBooks sync',
  'One unified inbox for calls, texts, Yelp, Google & Meta',
  'Easy onboarding + a setup call',
  'Monthly support and monthly ad reporting',
]

export type WebsiteTier = {
  name: string
  price: string
  hosting: string
  includes: string[]
  featured?: boolean
}

export const websiteTiers: WebsiteTier[] = [
  {
    name: 'Starter Site',
    price: '$500',
    hosting: '+ $30/month hosting',
    includes: [
      'Built to turn visitors into calls',
      '3 pages (Home, Services, Contact)',
      'Mobile responsive',
      'Contact form',
      'On-page SEO',
    ],
  },
  {
    name: 'Growth Site',
    price: '$850',
    hosting: '+ $30/month hosting',
    featured: true,
    includes: [
      'Everything in Starter',
      '5–7 pages',
      'Custom design',
      'Service-specific pages',
      'Testimonials / trust section',
      'Conversion CTAs',
      'On-page SEO',
      'Google Analytics setup',
    ],
  },
  {
    name: 'Premium Site',
    price: '$1,200+',
    hosting: '+ $30/month hosting',
    includes: [
      'Everything in Growth',
      '8–12 pages',
      'Full custom design',
      'Blog setup',
      'Multiple service pages',
      'Schema markup',
      'Lead capture',
      'Speed optimization',
    ],
  },
]
